export const transform_quantities_to_non_nested = data => {
  let new_quantities = [];

  if (data.quantities) {
    data.quantities.forEach(quantity => {
      quantity.details.forEach(detail => {
        new_quantities.push({
          ...detail,
          color: quantity.color,
        });
      });
    });

    return {
      ...data,
      quantities: new_quantities,
    };
  } else {
    return {
      ...data,
    };
  }
};

export const transform_quantities_to_nested = data => {
  let new_quantities = [];

  if (data.quantities) {
    data.quantities.forEach(quantity => {
      if (
        !new_quantities.find(
          new_quantity => new_quantity.color.code === quantity.color.code
        )
      ) {
        let new_quantity = {
          color: quantity.color,
          details: [],
        };

        data.quantities.forEach(quantity => {
          if (quantity.color.code === new_quantity.color.code)
            new_quantity.details.push({
              quantity: quantity.quantity,
              size: quantity.size,
            });
        });

        new_quantities.push(new_quantity);
      }
    });

    return {
      ...data,
      quantities: new_quantities,
    };
  } else {
    return {
      ...data,
    };
  }
};

export function numberWithCommas(x) {
  if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function numberWithOutCommas(x) {
  return x.toString().replace(/,/g, "");
}

export function isPersianNumber(input) {
  const persianNumberRegex = /^[\u06F0-\u06F9]+$/;
  return persianNumberRegex.test(input);
}

// Function to convert Persian numbers to English numbers
export function convertAllNumbersToEnglish(input) {
  const allNumbersMap = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };

  return input?.replace(/[۰-۹]/g, match => allNumbersMap[match]);
}

export function convetProductType(type) {
  switch (type) {
    case "physical":
      return "فیزیکی";
    case "digital":
      return "دیجیتال";
    case "support":
      return "حمایتی";
    default:
      return "نامشخص";
  }
}
